import React, { useState, useRef, useEffect, useContext } from "react";
import "./styles.css"; // Create this CSS file for styles
import enFlag from "../../../public/assets/en-flag.png";
import esFlag from "../../../public/assets/spain-flag.png";
import arrow from "../../../public/assets/icon/Outlined_arrow-right.svg";
import { useTranslation } from "react-i18next";
import { quoteContext } from "../../context/quotesContext";
const MobileSelectFlags = () => {
  const {setLanguage} = useContext(quoteContext);
  const [t, i18n] = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(()=>{
    const lenguaje = JSON.parse(localStorage.getItem('lenguaje'))?.label || 'es'
    return {
      flag: lenguaje==='en'? enFlag: esFlag,
      label: lenguaje==='en'? "en": "es",
    }
  });
  const hoverTargetRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (
      hoverTargetRef.current &&
      !hoverTargetRef.current.contains(event.target)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const setOptionAndSave = (option) => {
    localStorage.setItem("lenguaje", JSON.stringify(option));
  }

  const handleOptionClick = (flag, label) => {
    setSelectedOption({ flag, label });

    i18n.changeLanguage(label);
    setOptionAndSave({ flag, label });
    setLanguage(label);
  };


  useEffect(()=> {
    i18n.changeLanguage(JSON.parse(localStorage.getItem('lenguaje'))?.label || 'es');

  },[]);

  return (
    <div className="mobile-select-leng-container" ref={hoverTargetRef}>
      <div className="mobile-selected-lang-option" onClick={toggleDropdown}>
        <img src={selectedOption.flag} alt="Selected Flag" className="mobile-flag-icon" />
        {selectedOption.label}
        <img
          src={arrow}
          className={`mobile-flag-arrow ${isOpen ? "rotate" : ""}`}
        />
      </div>
      {isOpen && (
        <div className="mobile-select-with-flags">
          <div
            className={`mobile-flag-option ${selectedOption.label === "En" ? "selected" : ""}`}
            onClick={() => handleOptionClick(enFlag, "en")}
          >
            <img src={enFlag} alt="US Flag" className="mobile-flag-icon" />{t('english')}
          </div>
          <div
            className={`mobile-flag-option ${selectedOption.label === "Es" ? "selected" : ""}`}
            onClick={() => handleOptionClick(esFlag, "es")}
          >
            <img src={esFlag} alt="Spain Flag" className="mobile-flag-icon" /> {t('spanish')}
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileSelectFlags;
